import React from 'react';
import { AppProvider, AppContext } from '../components/context/listingsContext';
import { CollectionProvider, CollectionContext } from '../components/context/collectionsContext';

const Store = ({ knownCrawler, listings, appData, requestContext, children }) => (
    <AppProvider requestContext={requestContext} knownCrawler={knownCrawler} listings={listings} appData={appData}>
        <CollectionProvider appData={appData}>
            {children}
        </CollectionProvider>
    </AppProvider>
);

export default Store;
export { AppContext, CollectionContext };
